var lib_core = require("lib-core");
var editor_2d = require("editor-2d");

var MovingStateMachine = require("./../moving/movingStateMachine.js");

/**
 * The purpose of this state machine is to provide cut, copy and paste functionality.
 */
var CopyPasteStateMachine = function (root, assetType, editorModel, movingModel, selectionModel, useLocalStorage) {
    var self = this;

    this.root = root;
    this.assetType = assetType;

    this.editorModel = editorModel;
    this.movingModel = movingModel;
    this.selectionModel = selectionModel;

    this.useLocalStorage = useLocalStorage;

    this.clipboardRoot = new lib_core.ModelRoot();
    this.nrCopies = 0;

    editor_2d.MovingStateMachine.call(this, root, movingModel, editorModel, this.selectionModel.selection);

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.isKeyPressed('C_c');
        },
        function(cEvent){
            self.copySelection();
        }
    );

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.isKeyPressed('C_x');
        },
        function(cEvent){
            self.copySelection();
            self.root.rec();
            self.selectionModel.deleteSelection();
            self.root.stopRec();
        }
    );


    this.removeTransition(this.startMovingTransition);
    this.addTransition("idle", "moving",
        function(cEvent){
            return (cEvent.isKeyPressed('C_v') && (
                    (self.clipboardRoot.data && self.clipboardRoot.data.data.size() > 0) ||   // check if there is data to paste clipboard of this editor
                    (self.useLocalStorage && localStorage && localStorage["clipboard_type"] == self.assetType)));  // check if there is data to paste in localStorage
        },
        function(cEvent){
            self.root.rec();
            self.pasteClipboard();
        }
    );
};

lib_core.inherit(CopyPasteStateMachine, MovingStateMachine);

module.exports = CopyPasteStateMachine;

CopyPasteStateMachine.prototype.copySelection = function () {
    var self = this;
    this.nrCopies = 0;

    // get the data to copy
    var dataToCopy = new lib_core.Collections.HashSet();
    var collectionMap = new lib_core.Collections.HashMap();
    this.selectionModel.selection.forEach(function (IM) {
        if (!IM.isNotCopyable){
            dataToCopy.add(IM.data);
            collectionMap.put(IM.data, IM.data.getParentCollection());
        }
    });
    if (dataToCopy.isEmpty()) return;

    // clone the data into the clipboard
    var clipboard = new Clipboard();
    lib_core.ObservableTreeNode.cloneNodes(dataToCopy).forEach(function(data, clone){
        clipboard.data.add(clone);
        clipboard.collectionMap.put(clone, collectionMap.get(data));
    });
    this.clipboardRoot.attachData(clipboard);

    // store clipboard in localStorage if possible
    if (this.useLocalStorage && localStorage){
        var clipboardJson = {
            "data": this.clipboardRoot.jsonify(),
            "collectionMap": {}
        };
        clipboard.collectionMap.forEach(function(clone, col){
            clipboardJson["collectionMap"][clone.$id] = self.clipboardRoot.jsonifyPath(clone.parent().getPath()).concat(col.getName());
        });
        try {
            localStorage.setItem("clipboard_content", JSON.stringify(clipboardJson));   // TODO: maybe use name of editor as key if we want / need to avoid cross editor copy-paste
            localStorage.setItem("clipboard_id", clipboard.$id);
            localStorage.setItem("clipboard_type", this.assetType);
        } catch (err) {}                                                        // TODO: maybe clear the local storage at some point
    }
};

CopyPasteStateMachine.prototype.pasteClipboard = function () {
    var self = this;
    this.selectionModel.emptySelection();

    // get data to paste
    var clipboard = this.clipboardRoot.data;
    if (this.useLocalStorage && localStorage && localStorage["clipboard_type"] == this.assetType){
        if (!clipboard || clipboard.$id != localStorage["clipboard_id"]){   // if the clipboard in localStorage equals clipboard of this editor: unnecessary to dejsonify localStorage clipboard
            var clipboardJson = JSON.parse(localStorage.getItem("clipboard_content"));
            this.clipboardRoot = new lib_core.ModelRoot();
            clipboard = this.clipboardRoot.dejsonify(clipboardJson["data"]);
            this.clipboardRoot.attachData(clipboard);
            clipboard.data.forEach(function(data){
                clipboard.collectionMap.put(data, self.root.findByPath(clipboardJson["collectionMap"][data.$id])); // TODO: what if path is not found in destination root?
            });
        }
    }

    // clone the data from the clipboard and add it to their original collections, add the interactionmodel to the selection
    this.nrCopies++;
    lib_core.ObservableTreeNode.cloneNodes(clipboard.data).forEach(function(data, clone){
        clone.addTo(clipboard.collectionMap.get(data));
        var IM = self.editorModel.interactionModelDataMap.get(clone);
        if (IM.afterPaste) IM.afterPaste(self.nrCopies);
        self.selectionModel.addToSelection(IM);
    });

    // centrilize pasted objects around mouse
    var center = this.selectionModel.selectedBoundingBox().getCenter();
    var startCoord = this.editorModel.mousePos();
    var vec = startCoord.sub(center);
    this.selectionModel.selection.forEach(function(element) {
        element.move(vec, {});
    });
};

var Clipboard = function () {
    this.makeObservableTreeNode();
    this.data = this.set("data", true);
    this.collectionMap = new lib_core.Collections.HashMap(); // Map to store original owner collections of each copied data object
};
lib_core.mixin(Clipboard, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(Clipboard, "Clipboard");
